module.exports = __webpack_public_path__ + "img/icon-angle-left.ec9b9ac9.svg";